import React from "react"
import {peopleOutline, peopleSharp} from "ionicons/icons"

import TypeIcon from "./TypeIcon"

interface props {
    link?: string
    size?: "small" | "default" | "large"
    slot?: string
    text?: string
}

const IconPersonGroup: React.FC<props> = ({ link, size, slot, text }) => {

    return <TypeIcon
        backgroundColor={'pink'}
        link={link}
        ios={peopleOutline}
        md={peopleSharp}
        size={size}
        slot={slot}
        text={text}
    />

}

export default IconPersonGroup